import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

const updatePlayer = async (playerId, playerData) => {
  const url = `v1/orgs/${selectedOrgId()}/players/${playerId}`
  const response = await axiosInstance.patch(url, playerData)
  return response?.data
}

export default updatePlayer
